import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, timer } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { Version } from '../models/version.model';
import { AppConfig } from './app-config.service';

@Injectable({
  providedIn: 'root',
})
export class VersionCheckService {
  // this will be replaced by actual hash post-build.js
  private currentHash = '{{POST_BUILD_ENTERS_HASH_HERE}}';

  constructor(private http: HttpClient, private appConfig: AppConfig) {
  }

  private currentVersion: string;

  public get version(): string {
    return this.currentVersion;
  }

  private currentBuild: string;

  public get build(): string {
    return this.currentBuild;
  }

  /**
   * Checks if hash has changed.
   * This file has the JS hash, if it is a different one than in the version.json
   * we are dealing with version change
   */
  private static hasHashChanged(currentHash, newHash): boolean {
    if (!currentHash || currentHash === '{{POST_BUILD_ENTERS_HASH_HERE}}') {
      return false;
    }

    return currentHash !== newHash;
  }

  /**
   * Checks in every set frequency the version of frontend application
   */
  public init(url, frequency = 1000 * 30): Observable<Version> {
    if (!this.appConfig.config.demo && this.appConfig.config.versionCheck) {
      timer(0, frequency)
        .pipe(switchMap(() => this.checkVersion(url)))
        .subscribe();
      return this.checkVersion(url);
    }
    return of(null);
  }

  /**
   * Will do the call and check if the hash has changed or not
   */
  private checkVersion(url): Observable<Version> {
    // timestamp these requests to invalidate caches
    return this.http.get<Version>(url).pipe(
      tap((response: Version) => {
        const firstCheck = !this.version || !this.build;
        this.currentVersion = response.version;
        this.currentBuild = response.build;
        const { hash } = response;
        const hashChanged = VersionCheckService.hasHashChanged(this.currentHash, hash);

        if (firstCheck) {
          console.log('App version:', this.version, this.build);
        }

        if (hashChanged) {
          window.location.reload();
        }

        this.currentHash = hash;
      }),
    );
  }
}
